import { z } from 'zod';

export const MessengerLinkDisconnectReasonSchema = z.enum(['MEMBER', 'DEACTIVATED']);
export type MessengerLinkDisconnectReason = z.infer<typeof MessengerLinkDisconnectReasonSchema>;
